(function() {
  'use strict';

  angular
    .module('contentPlayer.emailTrainerCtrl', [])
    .controller('EmailTrainerCtrl', EmailTrainerCtrl);

  EmailTrainerCtrl.$inject = ['$scope', 'Auth', 'Navigation', 'ContentPlayerService', '$routeParams'];

  function EmailTrainerCtrl($scope, Auth, Navigation, ContentPlayerService, $routeParams) {
    if (Auth.getSelectedAccount()) {
      $scope.email = Auth.getSelectedAccount().email;
      $scope.name = Auth.getSelectedAccount().firstName + ' ' + Auth.getSelectedAccount().lastName;
    }

    $scope.modalData = {};

    $scope.sendEmail = function() {
      var dto = {
        pngImageBytes: [1, 2, 3],
        questionText: $scope.modalData.questionText,
        cModuleId: $routeParams.cModuleId,
        courseId: $routeParams.courseId,
        userEmail: $scope.email,
        slideNumber: Navigation.slideIndex + 1, // trainers won't expect the first slide to be slide 0
        slideCount: Navigation.numSlides
      };

      ContentPlayerService.sendEmailToTrainer(dto, function() {
        $scope.$close();
      });
    };
  }
})();
